module.exports = {"510604100":"万安镇","510604101":"鄢家镇","510604102":"金山镇","510604103":"略坪镇","510604104":"御营镇","510604105":"慧觉镇","510604106":"调元镇","510604107":"新盛镇","510604108":"蟠龙镇","510604113":"白马关镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510604.json
// module id = 2294
// module chunks = 0